import React from "react";
import type { BaseProvinceIconProps } from "./BaseProvinceIcon";

export const NunavutIcon = (props: BaseProvinceIconProps) => {
  return (
    <g
      id="NU"
      {...props}
    >
      <path
        d="M153.1,83.4c1.4,0,2.2,1.2,1.8,2.3c-0.5,1.2-0.9,2.3-1.3,3.5c-0.8,2.4-1.5,4.8-2.1,7.3
            c-0.2,0.7,0.1,1.7,0.6,2.3c0.9,1.2,2,2.5,3.2,3.4c2.8,2.2,3.9,5.1,3.6,8.5c-0.3,3.8,1,6.6,4.4,8.7c1.7,1,3.1,2.4,4.9,3.8
            c0.2,0.2,0.4,0.2,0.6,0.2c0.4,0,0.8-0.3,0.9-0.7c0.3-1.6,0.6-3.1,0.8-4.5c0.4-2.4,0.8-4.8,1.1-7.2c0.1-1,0.5-1.5,1.7-1.5
            c0.2,0,0.4,0,0.7,0c0.7,0.1,1.3,0.1,2,0.1c1.4,0,2.8-0.2,4.2-0.4c0.3-0.1,0.6-0.1,0.9-0.1c1.8,0,2.2,1.4,2.8,4.2
            c0.8,4.1,2.5,8,4.7,11.5c1.1,1.8,1.1,2.9,0.2,4.2c-6.2,9.1-12.4,18.2-18.6,27.3c-2.3,3.4-4.5,6.9-7,10.2c-1.7,2.3-2.5,9.7-2.5,10.8
            c0,1.5-0.5,2-1.7,2.1c-6.7,0.8-13.4,1.6-20,2.4c-0.6,0.1-1.6,0.2-2.3,0.3c-0.1,0-0.3,0-0.4,0c-0.8,0-1.1-0.4-1.2-1.5
            c-0.1-6.5-0.3-13-0.4-19.5c-0.1-2.5-0.3-5-0.3-7.5c0-1.4-0.7-2-1.9-2.3c-6.8-1.6-13.6-3.2-20.4-4.8c-3.1-0.7-6.1-1.4-9.2-2.2
            c-0.6-0.2-1.2-0.6-1.7-1.1c-6.7-7.1-13.3-14.3-19.9-21.5c-1-1.1-1-1.9,0.2-3.4c0.9-1.2,1.6-2.5,2.1-3.9c0.3-1.2,0.7-1.7,1.3-1.7
            c0.2,0,0.5,0.1,0.7,0.2c2.2,1.3,4.5,2.5,6.6,3.9c0.5,0.3,0.9,1.1,1,1.7c0.4,2.2,0.6,4.5,1,6.7c0.1,0.5,0.4,1.2,0.8,1.4
            c5.3,2.5,10.6,5,16.2,7.6c0.2,0.1,0.4,0.1,0.6,0.1c0.5,0,1.1-0.4,1.2-0.9c0.5-1.7,1-3.3,1.5-4.9c0.5-1.6,1-3.2,1.4-4.8
            c0.2-0.8,0.5-1.1,1-1.1c0.3,0,0.6,0.1,0.9,0.2c5.3,2.2,10.6,4.2,15.8,6.4c0.5,0.2,0.9,0.3,1.3,0.3c0.6,0,1.1-0.2,1.7-0.6
            c1.3-1,2.8-1.7,4-2.8c0.6-0.5,1.1-0.7,1.6-0.7c0.6,0,1.2,0.3,1.9,0.8c1.3,1,2.6,1.9,4.1,3c0.2,0.1,0.4,0.2,0.6,0.2
            c0.5,0,0.9-0.3,1-0.9c0.4-3.4,0.9-6.5,1.2-9.7c0.1-0.5-0.2-1.1-0.4-1.7c-1.8-4.4-3.6-8.8-5.3-13.2c-0.4-1.2-0.6-2.4-0.5-3.6
            c0.3-4.8,0.9-9.7,1.2-14.5c0.1-1.5,0.8-2,2.2-2.1C149.7,83.8,151.3,83.6,153.1,83.4L153.1,83.4z"
      />
      <path
        d="M220.2,195.7c0.4,0,0.8,0.1,1,0.2c1,0.6,1.1,2.1,0.3,3.4c-0.8,1.2-1.6,2.4-2.4,3.7c-0.2,0.3-0.5,0.4-0.8,0.4
            c-0.2,0-0.4-0.1-0.6-0.2c-3.4-3.2-2.9-2.4-0.2-6.4C218.1,196.2,219.2,195.7,220.2,195.7L220.2,195.7z"
      />
      <path
        d="M141.6,24.2c0.3,0,0.6,0.2,0.8,0.6c1.3,1.8,2.5,3.6,4.9,3.9c1.3,0.2,2.5,0.8,3.4,1.9c0.9,0.9,1.4,2.1,2.2,3.1
            c0.9,1,1.7,1.9,2.1,3.1c0.4,1.2,0.5,2.5,0,3.7c-0.2,0.4-0.4,0.7-0.5,1.1c-0.1,0.2-0.1,0.4-0.2,0.6c-0.6,1.5-1.2,3.1-1.8,4.7
            c-0.3,0.8-1.2,1.4-2.1,1.4c-0.1,0-0.3,0-0.4,0c-2-0.4-3.6-0.5-4.5-2.5c-1.4-3.1-2.8-6.1-4.2-9.1c-1-2.1-1.7-4.3-1.6-6.7
            c0.1-1.7,0-4.1,1.4-5.3C141.2,24.3,141.4,24.3,141.6,24.2L141.6,24.2z"
      />
      <path
        d="M171.6,0c0.6,0,1.2,0,1.8,0c1.3,0,2.6,0.8,4,1.2c0.9,0.2,1.1,0.7,0.8,1.5c-0.5,1.3-0.9,2.7-1.5,4.1
            c-0.5,1.1-0.5,1.9,0.8,2.3c1.6,0.5,1.9,1.6,1.7,3.1c-0.3,3.1-0.5,6.2-0.8,9.4c-0.1,0.6-0.4,1.3-0.7,1.9c-1.6,2.4-3.4,4.7-5,7.1
            c-0.3,0.4-0.3,1.5-0.1,1.7c3.2,2.1,3.2,5.6,4,8.8c0.8,3.1-0.9,5.2-2.2,7.5c-0.5,1-0.3,2.2,0.6,2.8c0.5,0.3,0.9,0.7,1.4,1
            c0.7,0.5,0.9,1.4,0.5,2.1c-1.1,1.8-2.1,3.6-3.2,5.3c-0.3,0.5-0.9,0.8-1.4,1c-0.7,0.3-1.5,0.3-2.2,0.6c-1.7,0.7-3.3,0.9-5,0.9
            c-2.4,0-4.7-0.6-7-1.4c-0.8-0.3-1.3-0.9-1.4-1.7c-0.5-3.5-1-7,0.2-10.6c0.4-1.1,0-2.5-0.1-3.8c0-0.3,0-0.6,0-0.9
            c0-0.7,0.4-1.3,1-1.7c0.8-0.5,1.7-1,2.5-1.6c1-0.6,1.3-2,0.7-3c-1.6-2.7-3.5-4.6-4.2-7.9c-0.3-1.4-3.2-1.8-4.2-2.5
            c-1.2-0.8-2.2-1.9-3.1-2.9c-1.8-2.1-1.9-4.4-1.8-6.8c0-0.5,0.6-1.1,1-1.4c1.2-0.9,2.5-1.7,3.8-2.4c1-0.6,2-1.1,1.8-2.6
            c0-0.4,0.5-0.9,0.9-1.2c3.4-2.8,6.8-5.5,10.1-8.2C167.1,0.2,169.3,0,171.6,0L171.6,0z"
      />
      <path
        d="M143.7,58.8c0.3,0,0.6,0.1,0.9,0.2c3,1.7,6.4,2.5,9.6,3.8c1.7,0.7,3.3,1.5,4.7,2.6c1.3,0.9,2.6,1.8,4.2,1.8
            c1.7,0,3.2-0.9,4.7-1.7c1.1-0.6,2.3-1.2,3.5-1.4c0.3-0.1,0.7-0.1,1-0.1c3.5,0,6.2,3.1,5.2,6.7c-0.2,0.9-0.7,1.7-1.4,2.3
            c-1.9,1.7-4.8,1.9-7,2.9c-2.3,1.1-4.6,2.4-7.1,2.6c-0.3,0-0.6,0.1-0.9,0.1c-0.5,0-1,0-1.5-0.1c-4.7-0.8-8.4-5.1-9.5-9.6
            c-0.3-1.1-0.9-2.1-2.1-2.3c-0.2,0-0.3,0-0.5,0s-0.3,0-0.5,0s-0.3,0-0.5,0c-0.1,0-0.3,0-0.4,0c-1.5-0.2-2.6-1.7-3.4-2.9
            c-0.7-1-1.4-2.6-0.7-3.9C142.3,59.2,142.9,58.8,143.7,58.8L143.7,58.8z"
      />
      <path
        d="M243.5,138.5l-2.7-2.1c-0.7-0.6-1-1.5-0.8-2.4s1-1.5,1.9-1.6l2.9-0.3c0.2,0,0.4,0,0.8-0.1
            c1.8-0.1,2.4-0.3,2.6-0.5c-1.4-2.2-15.6-11.9-17.5-12.7c-2.5-1-2.3-3.1-2.2-4s0.8-1.5,1.7-1.5c0.2,0,0.4,0,0.5,0.1l12,3.9
            c0.4,0,0.7-0.2,0.7-0.2c0.1-0.4-0.3-1.6-0.5-2.2c-0.1-0.4-0.3-0.8-0.3-1.1c-0.2-1.2-0.4-2.3-0.7-3.5c-0.4-2-0.7-4-1.3-6.1
            c-0.1,0-0.3-0.1-0.9-0.1c-0.2,0-0.8,0-1.2,0s-0.8,0-1.1,0c-0.9,0-1.9,0-2.9-0.2c-3.1-0.4-6-1.6-8.2-3.3c-0.3-0.3-1-0.4-1.5-0.4
            c-0.2,0-0.3,0-0.4,0.1c-2.4,0.7-3.8,0.9-4.8,0.9c-2,0-2.8-1.1-3.3-2.2c-1.2-2.9-2.5-5.8-3.8-8.5c-0.3-0.7-0.5-0.9-0.6-1
            c-0.9-0.2-1.8-0.4-2.6-0.6c-2.8-0.7-5.7-1.4-8.5-1.4c-3,0-5.5-0.5-7.6-2.8c-0.1-0.1-0.2-0.2-0.3-0.2c-0.2-0.2-0.5-0.4-0.7-0.7
            c-0.7-1-1.6-1.4-3-1.4c-0.4,0-0.9,0-1.6,0.1c-2.2,0.3-3.4,1-4.3,2.4c-0.4,0.7-0.9,1.2-1.6,1.9c-0.4,0.4-0.9,0.6-1.4,0.6
            c-0.7,0-1.3-0.3-1.6-0.9l-0.8-1.2c-1-1.6-2-3.2-3-4.8c-0.3-0.5-0.6-1-0.8-1.2c-0.2,0.1-0.6,0.3-0.9,0.5l-0.6,0.3
            c-3.3,1.7-4.3,3.7-3.6,6.8c0.2,0.7,0.2,1.4,0.1,2c-0.2,1-1,1.7-2.1,1.7s-2-0.8-2.1-1.9c-0.2-1.9,0.2-3.8,0.6-5.6
            c0.2-0.9,0.4-1.8,0.5-2.6c0-0.2-0.1-0.4-0.1-0.4c-0.1-0.1-0.3-0.2-0.5-0.2c-1.1,0.2-1.7,0.7-2.4,2.6c-0.2,0.6-0.4,1.3-0.7,1.9
            c-0.1,0.4-0.3,0.8-0.4,1.2c-1.2,3.4-2.2,6.3-0.8,9.9c1.6,4.3,3.6,7.3,6.3,9.7c0.9,0.8,1.6,1.2,2.5,1.2c0.2,0,0.3,0,0.5,0
            c2.5-0.3,5.1-0.6,7.6-0.8c1.5-0.2,3.1-0.3,4.6-0.5c0.3,0,0.7-0.1,1-0.1c1.3-0.1,2.5-0.2,3.5-0.7c0.3-0.1,0.6-0.5,1-0.8
            c0.7-0.7,1.5-1.5,2.8-1.5c0.9,0,1.8,0.5,2.5,0.9c0.2,0.1,0.4,0.2,0.5,0.3c1.1,0.6,2.2,1.2,3.3,1.7c4.7,2.5,8.9,4.8,12.7,6.9
            c0.9,0.5,1.7,1.6,1.9,2.7c0.2,1.5,0.4,3,0.6,4.4c0.1,0.8,0.2,1.7,0.3,2.6c0.3,2,0.6,4,0.9,6.1l0.2,1.5c0.2,1.2-0.6,2.3-1.8,2.6
            l-1.2,0.3c-0.9,0.2-1.7,0.5-2.6,0.7c-1.3,0.4-3.1,0.3-2.8,2.2c0.3,1.4,0.8,4.4,2.7,4.4c0.8,0,1.6-0.6,2.3-0.9
            c0.8-0.4,1.6-0.7,2.4-1c0.7-0.2,1.4-0.6,2.1-1c1.2-0.7,2.5-1.4,4-1.6c0.2,0,0.4-0.1,0.6-0.1c1.3,0,2.3,0.6,3.2,1.2
            c0.2,0.1,0.4,0.3,0.6,0.4c1.8,1.1,3.2,1.9,4.5,2.6c0.4,0.2,0.8,0.5,1.3,0.7c1.5,0.9,3.2,1.9,4.9,1.9c1.1,0,2.1,0,3.2,0
            c1.1,0,2.2,0,3.3,0c0.8,0,1.6,0,2.3,0h0.4c0.4,0,0.9,0,1.4,0c0.9,0,1.6-0.1,2.1-0.2c0.2-0.1,0.3-0.1,0.4-0.2
            c-0.5-0.6-2.1-1.6-2.7-2C244.1,138.9,243.7,138.7,243.5,138.5L243.5,138.5z"
      />
      <path
        d="M134.2,34.2c0.2,0,0.4,0,0.6,0.1c0.9,0.3,1.8,0.7,2.4,1.2c0.2,0.2,0.2,0.8,0.1,1.5c-0.1,0.8-0.8,1.3-1.5,1.3
            c-0.2,0-0.3,0-0.5-0.1l0,0c-0.6-0.3-1.2-0.6-1.9-1c-0.6-0.3-0.9-1-0.8-1.6v-0.1C132.8,34.7,133.4,34.2,134.2,34.2L134.2,34.2z"
      />
      <path
        d="M126.2,40.2c0.5,0,1.1,0.3,2.3,0.7c2.1,0.7,3.7,2.4,5,4.1c1.2,1.6,5,5.5,2.6,7.5c-0.3,0.3-0.7,0.5-1.1,0.6
            c-0.3,0.1-0.7,0.2-1,0.2c-0.2,0-0.4,0-0.5,0c-2.1,0-4-1.9-5.8-2.8c-1.1-0.5-1.9-0.9-1.1-2.2c0.2-0.3,0-1-0.2-1.4
            c-0.6-1-1.4-2-2-3.1c-0.3-0.5-0.3-1.4,0-1.9C125.3,40.7,125.6,40.2,126.2,40.2L126.2,40.2z"
      />
      <path
        d="M133.8,63c0.7,0,1.8,0.2,3.3,0.6c0.3,0.1,0.6,0.1,0.9,0.2c0.8,0.2,1.4,1,1.4,1.8v7.8c0,1.1-0.9,1.9-1.9,1.9
            c-0.1,0-0.2,0-0.4,0c-2.2-0.4-4-0.9-5.5-2.9c-2.2-2.9-2.4-2.7-0.9-5.9C132,63.9,132.4,63,133.8,63L133.8,63z"
      />
      <path
        d="M199.7,113.2c0.9,0,1.8,0.3,2.4,1.1c0.6,0.8,1.3,1.5,2.2,2c1.5,0.9,2.1,1.5,1.2,2.5c-1.6,1.7-3.1,3.5-4.7,5.3
            c-0.3,0.4-0.8,0.6-1.3,0.6c-0.4,0-0.7-0.1-1-0.3c-1.2-0.8-2.3-1.6-3.4-2.5c-0.5-0.4-0.7-1.2-0.5-1.8c0.6-1.8,1.4-3.4,2.2-5.1
            C197.3,113.9,198.5,113.2,199.7,113.2L199.7,113.2z"
      />
      <path
        d="M184.2,142.5c0.1,0,0.2,0,0.3,0.1c3.2,2,6.8,1.7,10.3,2.1c1.8,0.2,2.9,0.8,3.6,2.4c0.4,1,1,1.9,1.5,2.9
            c-0.1,0.2-0.2,0.3-0.3,0.5c-3-0.2-6-0.4-9-0.7c-0.2,0-0.4,0-0.6,0c-0.9,0-1.4,0.3-1.9,1.3c-0.8,1.8-2.5,5.2-3.4,6.8
            c-0.2,0.5-0.7,0.8-1.3,0.8c-0.1,0-0.3,0-0.4-0.1l-4.6-1.3c-0.7-0.2-1.1-0.9-1-1.7c0.6-2.9,2.2-9.8,5.4-12.7
            C183.2,142.7,183.8,142.5,184.2,142.5L184.2,142.5z"
      />
      <path
        d="M140.1,46c0.1,0,0.3,0,0.4,0.1c2.4,0.8,4.1,3,3.9,5.4c-0.1,0.5-0.4,0.9-0.8,1.4c-0.2,0.3-0.6,0.4-0.9,0.4
            c-0.4,0-0.8-0.2-1-0.5c-1.3-1.8-2.7-3.3-2.7-5.5C138.9,46.5,139.5,46,140.1,46L140.1,46z"
      />
      <path
        d="M145.1,70.6c1.7,0,2.6,1.3,3.8,2.2c0.2,0.2,0.1,1-0.1,1.4c-0.2,0.5-0.5,1-0.8,1.5c-0.4,0.7-1.1,1-1.8,1
            c-0.4,0-0.8-0.1-1.1-0.3c-0.8-0.5-1.6-1-2.3-1.6c-0.3-0.3-0.6-1.2-0.4-1.5c0.7-1,0.6-2.6,2.3-2.7C144.9,70.6,145,70.6,145.1,70.6
            L145.1,70.6z"
      />
      <path
        d="M203.6,157.3c0.6,0,1.2,0.3,1.6,0.8c0.6,0.7,1.1,1.5,1.5,2.3c0.3,0.5,0.1,1.4-0.2,2c-1.1,1.9-1.3,2.8-1.9,2.8
            c-0.5,0-1.1-0.6-2.7-1.6c-1.4-0.8-1.6-1.7-0.9-3.1c0.4-0.7,0.5-1.6,0.9-2.3C202.4,157.6,203,157.3,203.6,157.3L203.6,157.3z"
      />
      <path
        d="M125.1,55.2c0.3,0,0.7,0.1,0.9,0.3c1.2,1,1.8,1.8,1.8,2.8c0.1,0.9-0.7,1.6-1.5,1.6c-0.3,0-0.5-0.1-0.8-0.2
            c-1.3-0.8-2-1.8-1.9-3.1C123.7,55.7,124.4,55.2,125.1,55.2z"
      />
      <path
        d="M137.7,81.8c0.5,0,1.4,0.6,1.7,1.1c0.9,1.4,1.3,2.9,0.9,4.2c-0.4,1.5-0.3,3,0.4,4.3l0.1,0.2
            c0.3,0.7,0.4,1.5,0.8,2.1c1.3,2.4,0.8,4.7-0.7,6.8c-0.3,0.4-1,0.8-1.5,0.8h-0.1c-1.4-0.1-2.7-0.5-4.1-0.8c-0.5-0.1-1-0.4-1.3-0.7
            c-1.5-2.2-3-4.4-4.5-6.7c-0.6-0.8-0.4-2,0.5-2.6c1.1-0.8,1.2-2.1,0.9-3.5c-0.3-2,0.4-3.2,2.5-3.8c1.4-0.4,2.8-1.1,4.3-1.4
            C137.6,81.8,137.7,81.8,137.7,81.8L137.7,81.8z"
      />
      <path
        d="M140.3,113.6c0.2,0,0.4,0.1,0.6,0.2c0.3,0.2,0.6,0.5,0.9,0.7c1.2,1.1,2.4,2.3,3.8,3.1c2.5,1.4,2.3,3.4,1.7,5.7
            c-0.2,0.6-0.4,0.9-0.8,0.9c-0.2,0-0.4-0.1-0.7-0.2c-2.8-1.7-5.6-3.3-8.3-5.1c-0.3-0.2-0.5-1-0.3-1.3c0.7-1.2,1.4-2.3,2.2-3.6
            C139.6,113.8,140,113.6,140.3,113.6L140.3,113.6z"
      />
      <path
        d="M195.6,155.5c1.5,0,1.6,0.5,1.7,2.6c0.1,1.1,0.1,2.2-0.3,3.1c-0.4,0.7-2.2,1.8-3.7,2.4
            c-0.2,0.1-0.4,0.1-0.6,0.1c-0.8,0-1.5-0.6-1.5-1.4c-0.1-1.3-0.2-2.6-0.2-3.9c0-1.1,2.2-2.9,3.4-3
            C194.8,155.5,195.2,155.5,195.6,155.5L195.6,155.5z"
      />
      <path
        d="M209.4,146.3c0.7,0,1.2,0.5,1.4,1c0.3,0.6,0.1,1.9-0.4,2.4c-0.9,0.9-2,1.6-3.1,2.4c-0.1,0.1-0.3,0.1-0.4,0.1
            c-0.3,0-0.6-0.2-0.7-0.4c-0.3-0.8-0.7-1.6-1-2.4c-0.1-0.3,0-0.7,0.3-0.9c1-0.6,2-1.1,2.9-1.8C208.8,146.4,209.1,146.3,209.4,146.3
            L209.4,146.3z"
      />
      <path
        d="M116.7,76.7c0.9-0.6,2-1,3.1-1c0.7,0,1.5,0,2.2,0s1.4,0,2.1,0c0.9,0,1.6-0.9,1.3-1.8c-0.4-1.3-0.9-2.5-1.2-3.7
            c-0.4-1.5-1.2-2.7-2.8-3.2c-1.1-0.3-1.6-1.1-1.7-2.3c-0.2-0.4-0.4-0.8-0.5-1.2c-0.3-0.6-0.5-1-1.2-1.1l-0.2-0.1
            c-0.2,0-0.4-0.1-0.6-0.1c-0.4,0-0.8,0.1-1.2,0.4c-1.1,1.3-2,2.6-1.5,4.4c0.3,0.9-0.4,1.8-1.3,1.8c-0.2,0-0.3-0.1-0.5-0.1l0.6,10.3
            C114.4,78.3,115.5,77.5,116.7,76.7L116.7,76.7z"
      />
      <path
        d="M133,114.8c-1.3-1.1-2.6-2.1-3.7-3.3c-0.8-0.8-1.5-1.9-1.9-3c-1-2.9-1.9-5.8-2.7-8.7c-0.4-1.4-0.6-2.8-0.6-4.2
            c0-2,0.3-4,0.4-6.1c0.1-0.7-0.5-1.1-1.1-1.1c-0.2,0-0.4,0.1-0.6,0.2c-1,0.6-1.9,1.2-2.8,1.8c-1,0.7-2,2.2-2.2,3.4
            c-0.3,1.4-0.4,2.9-0.6,4.3c-0.4-0.6-0.5-1.2-0.9-1.4c-1.2-0.7-2.5-1.5-3.8-2.2l-5.3,18.7l-13.9-3.5c0.1,0.4,0.2,0.8,0.5,1.1
            c2.3,2.4,5.1,4.6,7,7.3c1.7,2.3,3.5,3.3,5.6,3.3c1.1,0,2.2-0.2,3.5-0.7c3.2-1.2,6.5-2,9.8-2c2.6,0,5.3,0.5,7.9,1.8
            c0.1,0,0.2,0.1,0.3,0.1c0.4,0,0.8-0.2,1.1-0.4c1.4-1.2,2.7-2.5,4-3.7C133.9,115.8,133.7,115.3,133,114.8L133,114.8z"
      />
      <path
        d="M117.8,50c0.6,0,1-0.5,1-1c-0.1-0.6-0.1-1.3-0.1-1.9l-1.2,2.9C117.6,50,117.6,50,117.8,50
            C117.7,50,117.7,50,117.8,50L117.8,50z"
      />
      <path
        d="M115.6,57.6c0.2,0.1,0.4,0.1,0.7,0.1c0.3,0,0.5,0,0.6-0.2c0.6-0.9,1.2-1.9,1.8-2.9c0.5-0.8,0.1-1.9-0.8-2.2
            c-0.4-0.1-0.7-0.2-1.1-0.4l-2,5.1C115,57.3,115.3,57.4,115.6,57.6L115.6,57.6z"
      />
    </g>
  );
};
